import script from "./Computer.vue?vue&type=script&setup=true&lang=js"
export * from "./Computer.vue?vue&type=script&setup=true&lang=js"

import "./Computer.vue?vue&type=style&index=0&id=abb4cf02&scoped=true&lang=scss"
import "./Computer.vue?vue&type=style&index=1&id=abb4cf02&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abb4cf02"]])

export default __exports__